import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingPlaceholder: {
    id: 'sku-modifier-group-picker.loading-placeholder',
    defaultMessage: 'Loading…',
  },
  loadingBelow: {
    id: 'sku-modifier-group-picker.loading-below',
    defaultMessage: 'Loading modifiers…',
  },
  fetchFailed: {
    id: 'sku-modifier-group-picker.fetch-failed',
    defaultMessage: "Couldn't load your modifiers. You can still save this item.",
  },
  fetchFailedReadOnly: {
    id: 'sku-modifier-group-picker.fetch-failed-read-only',
    defaultMessage: "Couldn't load this item's modifiers.",
  },
  tryAgain: {
    id: 'sku-modifier-group-picker.try-again',
    defaultMessage: 'Try again',
  },
  emptyBelow: {
    id: 'sku-modifier-group-picker.empty-below',
    defaultMessage: 'No modifiers yet. Create one to let customers customize this item.',
  },
  createModifier: {
    id: 'sku-modifier-group-picker.create-modifier',
    defaultMessage: 'Create modifier',
  },

  label: {
    id: 'sku-modifier-group-picker.label',
    defaultMessage: 'Select modifiers',
  },
  searchPlaceholder: {
    id: 'sku-modifier-group-picker.search-placeholder',
    defaultMessage: 'Select modifiers',
  },
  readOnlyLabel: {
    id: 'sku-modifier-group-picker.read-only-label',
    defaultMessage: 'Modifiers',
  },
  noneAttached: {
    id: 'sku-modifier-group-picker.none-attached',
    defaultMessage: 'This item has no modifiers.',
  },
  addModifierGroup: {
    id: 'sku-modifier-group-picker.add-modifier-group',
    defaultMessage: 'Add modifier',
  },
  noGroups: {
    id: 'sku-modifier-group-picker.no-groups',
    defaultMessage: 'No modifiers available. Add a modifier to get started.',
  },
  noResults: {
    id: 'sku-modifier-group-picker.no-results',
    defaultMessage: 'No modifiers found.',
  },
  removeGroup: {
    id: 'sku-modifier-group-picker.remove-group',
    defaultMessage: 'Remove',
  },
  removeGroupAriaLabel: {
    id: 'sku-modifier-group-picker.remove-group-aria-label',
    defaultMessage: 'Remove {groupName}',
  },
});
